// @flow

import React from 'react';
import styled from 'styled-components';

import YouTube from 'react-youtube';

const Block = styled.div`
  margin: 15px 0;
`;

type TrevorBlock = {
  type: string,
  data: Object,
}

type Props = {
  body: Array<TrevorBlock>
}

function renderBlock(block: Object) {
  switch (block.type) {
    case 'video':
      return (
        <YouTube
          videoId={block.data.remoteId}
        />
      )
    default: // text
      return <div>{block.data.text}</div>;
  }
}

function ArticleContent({ body }: Props) {
  return (
    <div>
      {body.map((x, index) => (
        <Block key={index.toString()}>
          {renderBlock(x)}
        </Block>
      ))}
    </div>
  )
}

export default ArticleContent;



// WEBPACK FOOTER //
// ./src/components/ArticleDrawer/ArticleContent.js